function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ddd",
  d: "M15 .827V14.17a.827.827 0 0 1-.827.827h-3.824V9.19h1.949l.291-2.264h-2.243V5.481c0-.656.18-1.102 1.122-1.102h1.198V2.354c-.207-.027-.917-.09-1.747-.09-1.728 0-2.913 1.054-2.913 2.993v1.67H6.05v2.264h1.956V15H.827A.829.829 0 0 1 0 14.173V.827A.83.83 0 0 1 .827 0H14.17a.83.83 0 0 1 .83.827z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNkZGQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE1IC44MjdWMTQuMTdhLjgyNy44MjcgMCAwIDEtLjgyNy44MjdoLTMuODI0VjkuMTloMS45NDlsLjI5MS0yLjI2NGgtMi4yNDNWNS40ODFjMC0uNjU2LjE4LTEuMTAyIDEuMTIyLTEuMTAyaDEuMTk4VjIuMzU0Yy0uMjA3LS4wMjctLjkxNy0uMDktMS43NDctLjA5LTEuNzI4IDAtMi45MTMgMS4wNTQtMi45MTMgMi45OTN2MS42N0g2LjA1djIuMjY0aDEuOTU2VjE1SC44MjdBLjgyOS44MjkgMCAwIDEgMCAxNC4xNzNWLjgyN0MwIC4zNzIuMzcyIDAgLjgyNyAwSDE0LjE3YS44My44MyAwIDAgMSAuODMuODI3eiIvPgo8L3N2Zz4K";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook_gray.svg
// module id = 697
// module chunks = 32